import React, { useEffect, useState } from "react";
import CommonModal from "./CommonModal";
import { callAPI } from "../../utils/apiUtils";
import { apiUrls } from "../../utils/apiUrls";
import { toast } from "react-toastify";

const DriverUpdateModal = ({ isOpen, orderId, onClose, onSuccess }) => {
  const [drivers, setDrivers] = useState([]);
  const [driverId, setDriverId] = useState("");
  const [loading, setLoading] = useState(false);

  // Fetch drivers and current order driver when modal opens
  useEffect(() => {
    if (!orderId || !isOpen) return;

    setLoading(true);
    callAPI(`${apiUrls.EDIT_ORDER_DRIVER}?id=${orderId}`, "GET")
      .then((res) => {
        if (res.data?.status === 1) {
          setDrivers(res.data.employee || []); // fixed typo
          setDriverId(res.data.data?.driver_id || "");
        } else {
          toast.error(res.data?.message || "Failed to load drivers");
        }
      })
      .catch((err) => {
        console.error(err);
        toast.error("Error fetching driver details");
      })
      .finally(() => setLoading(false));
  }, [orderId, isOpen]);

  const handleSave = async () => {
    if (!driverId) {
      toast.error("Please select a driver");
      return;
    }

    setLoading(true);
    try {
      const res = await callAPI(
        apiUrls.UPDATE_ORDER_DRIVER,
        {},
        "POST",
        {
          order_id: orderId,
          driver_id: driverId,
        }
      );

      if (res.data?.status === 1) {
        toast.success("Driver updated successfully");
        onSuccess?.();
        handleClose();
      } else {
        toast.error(res.data?.message || "Update failed");
      }
    } catch (err) {
      console.error(err);
      toast.error(err.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setDriverId("");
    setDrivers([]);
    onClose();
  };

  return (
    <CommonModal isOpen={isOpen} onClose={handleClose} elId="driverUpdateModal">
      <div className="modal-header">
        <h5 className="modal-title">Update Driver</h5>
        <button className="btn-close" onClick={handleClose}></button>
      </div>

      <div className="modal-body">
        {loading ? (
          <p>Loading...</p>
        ) : (
          <select
            className="form-control"
            value={driverId}
            onChange={(e) => setDriverId(e.target.value)}
          >
            <option value="">Select Driver</option>
            {drivers.map((d) => (
              <option key={d.id} value={d.id}>
                {d.first_name} {d.last_name}
              </option>
            ))}
          </select>
        )}
      </div>

      <div className="modal-footer">
        <button className="btn btn-secondary" onClick={handleClose} disabled={loading}>
          Cancel
        </button>
        <button className="btn btn-primary" onClick={handleSave} disabled={loading}>
          Save
        </button>
      </div>
    </CommonModal>
  );
};

export default DriverUpdateModal;
